import './CitizenPortal.scss';
import { Col, Row } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import HeroCitizen from './components/HeroCitizen';
import PriceLookup from './components/PriceLookup';
import UserRegionComparison from './components/UserRegionComparison';
import MonitoredProducts from './components/MonitoredProducts';
import RecentReports from './components/RecentReports';
import FairPricesPromotion from './components/FairPricesPromotion';
import { useRef } from 'react';
import { Link } from 'react-router-dom';

const CitizenPortal = () => {
  const { t } = useTranslation(['citizenPortal']);

  // const monitoredProductsRef = useRef<HTMLDivElement>(null);
  // const priceMapRef = useRef<HTMLDivElement>(null);

  // const scrollToMonitoredProducts = () => {
  //   if (monitoredProductsRef.current) {
  //     monitoredProductsRef.current.scrollIntoView({
  //       behavior: 'smooth', // makes it smooth
  //       block: 'start', // align to top
  //     });
  //   }
  // };

  // const scrollToPriceMap = () => {
  //   if (priceMapRef.current) {
  //     priceMapRef.current.scrollIntoView({
  //       behavior: 'smooth', // makes it smooth
  //       block: 'start', // align to top
  //     });
  //   }
  // };

  return (
    <Row className="citizen-portal-main-container p-6">
      <Col span={24} className="mb-16">
        <HeroCitizen t={t} />
        <FairPricesPromotion t={t} />
        <div className="section mx-10">
          <p>
            <Trans
              i18nKey="disclaimerNote"
              ns="citizenPortal"
              components={{
                Link: <Link to="/#" className="text-blue-600 hover:underline" />,
              }}
            />
          </p>
        </div>
        <div id="price-lookup-section">
          <PriceLookup t={t} />
        </div>
        <div id="price-map-section">
          <UserRegionComparison t={t} />
        </div>
        <div id="monitored-products-section">
          <MonitoredProducts t={t} />
        </div>
        <div id="reports-section">
          <RecentReports t={t} />
        </div>
      </Col>
    </Row>
  );
};

export default CitizenPortal;
